import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { dailySessionNotes } from '../../actions/constant';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';

const {
  GET_ARCHIVED_DOCUMENTS_REQUEST,
  GET_ARCHIVED_DOCUMENTS_SUCCESS,
  GET_ARCHIVED_DOCUMENTS_FAILURE,
  GET_ARCHIVED_DOCUMENTS_LOADING,
} = dailySessionNotes;

function* getArchivedDocuments(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_ARCHIVED_DOCUMENTS_LOADING });
    const response = yield call(dailySessionNotesService.getArchivedDocuments, action?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_ARCHIVED_DOCUMENTS_SUCCESS, payload: response.data });
    } else {
      throw response?.data;
    }
  } catch (error: any) {
    yield put({
      type: GET_ARCHIVED_DOCUMENTS_FAILURE,
      payload: error?.response?.data || error,
    });
  }
}

function* getArchivedDocumentsSaga() {
  yield takeLatest(GET_ARCHIVED_DOCUMENTS_REQUEST, getArchivedDocuments);
}

export default getArchivedDocumentsSaga;
